// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Wwed","header":"ReportDetails_header__3j_8S","title":"ReportDetails_title__3hJBV","left":"ReportDetails_left__3uk1P"};